<template>
  <el-row :gutter="20" style="margin-left:5px; margin-right:5px;">
    <p style="white-space:nowrap;">
      <span style="font-weight:bold;font-size:18px;">{{result.data.destName}}</span>&nbsp;
      <span style="font-weight:bold;font-size:14px;">地址：{{result.data.address}}</span>
    </p>
    <div style="cursor:pointer;width:100%;position:relative;">
      <img
        :src="result.data.imgUrl"
        style="width:100%;height:400px"
        v-show="!vr.sceneImgs && !vr.sceneVr"
      />
      <div style="width:100%;height:400px" v-show="vr.sceneImgs || vr.sceneVr">
        <div style="border: 1px solid #888;width:100%;height:400px">
          <img :src="result.data.imgUrl" style="width:100%;height:400px" v-show="selectedType==''" />
          <iframe
            :src="vr.sceneImgs"
            style="border: 0; height: 100%; width: 100%;cursor:pointer"
            v-show="selectedType==1"
          ></iframe>
          <div :id="id" class="pan" v-show="selectedType==2"></div>
        </div>
        <!-- <div
          style="border: 1px solid #888;width:100%;height:400px;position:relative"
          v-show="selectedType==2"
        >
          <img
          :src="result.data.imgUrl"
            style="width:100%;height:400px" 
             v-show="selectedgg==3"        
          />
          <div :id="id" class="pan"  v-show="selectedgg==2"></div>
        </div>-->
        <div
          class="quanjing"
          v-bind:class="{selected: 1 == selectedType}"
          v-on:click="selectType(1)"
          v-show="vr.sceneImgs != null&&vr.sceneImgs !=''"
        ></div>
        <div
          class="vr"
          v-bind:class="{selected: 2 == selectedType}"
          v-on:click="selectType(2)"
          v-show="vr.sceneVr != null&&vr.sceneVr !=''"
        ></div>
      </div>
    </div>
    <el-row style="padding-top:18px;padding-bottom:18px;">
      <a style="padding-right:30px;" href="#jieshao">
        <el-button class="key" type="info" plain>景区介绍</el-button>
      </a>
      <!-- <a style="padding-right:30px;" href="#zhusu">
        <el-button class="key" type="info" plain>周边住宿</el-button>
      </a>-->
      <a style="padding-right:30px;" href="#canguan">
        <el-button class="key" type="info" plain>周边餐馆</el-button>
      </a>
      <a style="padding-right:30px;" href="#jingdian">
        <el-button class="key" type="info" plain>周边景点</el-button>
      </a>
      <a style="padding-right:30px;" href="#weizhi">
        <el-button class="key" type="info" plain>地图位置</el-button>
      </a>
      <a style="padding-right:30px;" href="#dianping">
        <el-button class="key" type="info" plain>点评</el-button>
      </a>
    </el-row>
    <div id="jieshao" style="width:100%;padding-top: 10px">
      <p>
        <img
          style="width:24px;height:24px;top: 5px;position: relative"
          src="../../assets/portal/jinqujieshao.png"
        />&nbsp;
        <span style="font-weight:bold;font-size:18px;">景区介绍</span>
      </p>
      <!-- <p style="font-size: 16px;">{{desc.description}}</p> -->
      <p style="font-size: 16px;" class="detail" v-html="desc.jieShao"></p>
    </div>
    <!-- <div id="zhusu" style="width:100%;padding-top: 10px" >
      <img
        style="width:24px;height:24px;position: relative;top:5px"
        src="../../assets/portal/Hotel.png"
      />&nbsp;
      <span style="font-weight:bold;font-size:18px;">周边住宿</span>
      <br />
      <br />
      <div style="height:250px">
        <swiper :options="swiperOption" ref="mySwiper">
          <swiper-slide v-for="(item,index) in result.data.mercChild" :key="index">
            <div @click="handleHotelDetail(item)">
              <img src="../../assets/portal/default.png" v-if="item.imgUrl==null ||item.imgUrl==''" />
              <img :src="item.imgUrl" v-else />
              <p class="title">{{item.mercName}}</p>
              <p class="address">地址：{{item.address}}</p>
            </div>
          </swiper-slide>
          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
      </div>
    </div>-->
    <div id="canguan" style="width:100%;padding-top: 10px">
      <img
        style="width:24px;height:24px;position: relative;top:5px"
        src="../../assets/portal/Restaurant.png"
      />&nbsp;
      <span style="font-weight:bold;font-size:18px;">周边餐馆</span>
      <br />
      <br />
      <div style="height:250px" v-if="mercChild.length!=0">
        <swiper :options="swiperOption" ref="mySwiper">
          <!-- slides -->
          <swiper-slide v-for="(item,index) in result.data.mercChild" :key="index">
            <div @click="handleFoodDetail(item)">
              <img src="../../assets/portal/default.png" v-if="item.imgUrl==null ||item.imgUrl==''" />
              <img :src="item.imgUrl" v-else />
              <p class="title">{{item.mercName}}</p>
              <p class="address">地址：{{item.address}}</p>
            </div>
          </swiper-slide>
          <!-- Optional controls -->
          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
      </div>
      <!-- <div style="font-size:16px;text-align:center;" v-else>暂无数据</div> -->
      <el-alert title="暂无数据" type="warning" show-icon center :closable="false" v-else></el-alert>
    </div>
    <!-- <div v-show="result.data.isScenicSpot =='1'"> -->
    <div id="jingdian" style="width:100%;padding-top: 10px">
      <img
        style="width:24px;height:24px;position: relative;top:5px"
        src="../../assets/portal/shopping.png"
      />
      &nbsp;
      <span style="font-weight:bold;font-size:18px;">周边景点</span>
      <br />
      <br />
      <div style="height:250px" v-if="childScenic.length!=0">
        <swiper :options="swiperOption" ref="mySwiper">
          <!-- slides -->
          <swiper-slide v-for="(item,index) in result.data.childScenic" :key="index">
            <div @click="handleDestDetail(item)">
              <img src="../../assets/portal/default.png" v-if="item.imgUrl==null ||item.imgUrl==''" />
              <img :src="item.imgUrl" v-else />
              <p class="title">{{item.name}}</p>
              <p class="address">地址：{{item.address}}</p>
            </div>
          </swiper-slide>
          <!-- Optional controls -->
          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
      </div>
      <el-alert title="暂无数据" type="warning" show-icon center :closable="false" v-else></el-alert>
    </div>
    <!-- </div> -->
    <div id="weizhi" style="width:100%">
      <img
        style="width:24px;height:24px;position: relative;top:5px"
        src="../../assets/portal/Maplocation.png"
      />&nbsp;
      <span style="font-weight:bold;font-size:18px;">地图位置</span>
      <br />
      <br />
      <!-- <div id="allmap" style="width:100%;height:320px"></div> -->
      <baidu-map
        v-if="result.data.lng"
        :center="{lng: result.data.lng, lat: result.data.lat}"
        :zoom="12"
        :scroll-wheel-zoom="true"
        style="width:100%;height:320px;"
      >
        <bm-marker :position="{lng: result.data.lng, lat: result.data.lat}">
          <bm-label
            :content="result.data.destName"
            :labelStyle="{color: 'red', fontSize : '16px'}"
            :offset="{width: 0, height: -30}"
          />
        </bm-marker>
      </baidu-map>
    </div>
    <!-- 评论模块 -->
    <div id="dianping">
      <portal-comment-page :productedId="result.data.destId" productedType="spot"></portal-comment-page>
    </div>
  </el-row>
</template>
<script>
// import Swiper from "../../../node_modules/swiper/dist/js/swiper.js";
// import "../../../node_modules/swiper/dist/css/swiper.css";
import Vue from "vue";
import BaiduMap from "vue-baidu-map";
import vueSwiper from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import { debuglog } from "util";
import { save as handleSave } from "../../actions/basis/save";

Vue.use(vueSwiper);

Vue.use(BaiduMap, {
  // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
  ak: "9862E14DE5d6373de36cd8e91503044b"
});

export default {
  name: "portal-sest-detail-spot",
  data() {
    return {
      userId: "",
      textarea: "",
      selectedType: "",
      selectedgg: "3",
      swiperOption: {
        spaceBetween: 20,
        slidesPerView: 4,
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        }
      },
      filter: {
        pageIndex: 1,
        pageSize: 4,
        typeId: "95ae8448-7974-4116-84ea-1223cc83957c"
      },
      id: "pan",
      tbConfig: {
        videoQuality: 1,
        videoList: []
      },
      aa: "",
      videoList: [],
      isShowAll: true,
      params: {
        container: null,
        name: "SceneViewer",
        isGyro: true, //默认开启陀螺仪功能  移动端支持陀螺仪设备有效
        isMouseWheel: false, //禁止滚轮缩放
        scenesArr: [],
        initOverCallBack: function() {
          this.isShowAll = false;
        },
        errorCallBack: function(e) {
          console.log("错误状态：" + e);
        },
        sceneEventClickCallBack: function(e) {
          if (this.isShowAll) {
            this.isShowAll = false;
          } else {
            this.isShowAll = true;
          }
        },
        fsCallBack: function(status, playObj) {
          alert("浏览器不支持全屏！");
        }
      }
    };
  },
  props: {
    result: {
      type: Object
    },
    routeWatch: {
      type: Boolean,
      default: true
    }
  },
  created() {
    this.id = "vr" + Math.ceil(Math.random() * 100000000);
  },
  mounted() {
    // setTimeout(function() {
    //   var aa = this.result.data.childVr;
    //   var sceneImgs = aa.sceneImgs;
    //   if (sceneImgs = "") {
    //     debugger;
    //     this.selectedType = 2;
    //   }
    // }, 2000);
  },
  components: {
    BsDetail: () => import("../../components/bs-detail"),
    BsPage: () => import("../../components/bs-page"),
    PortalCommentPage: () => import("./portal-comment-page")
    // PortalArtiDetailVr: () => import("./portal-arti-detail-vr")
  },
  methods: {
    selectType: function(number) {
      this.selectedType = number;
      this.selectedgg = number;
    },
    handleDestDetail(item) {
      this.$router.push({
        path: `/portal/dest/detail/destinations/spot_detail/${item.destId}`
      });
      //  window.location.href = `/portal/dest/detail/${moudle}/${field}_detail/${destId}`;
    },
    handleHotelDetail(item) {
      this.$router.push({
        path: `/portal/merc/detail/merchant/hotel_detail/${item.mercId}`
      });
    },
    handleFoodDetail(item) {
      this.$router.push({
        path: `/portal/merc/detail/merchant/food_detail/${item.mercId}`
      });
    },
    handleSpotDetail(item) {
      // this.$router.push({
      //   path: `/portal/merc/detail/merchant/food_detail/${item.mercId}`
      // });
      window.location.href = `/portal/dest/detail/${moudle}/${field}_detail/${item.destId}`;
    }
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
    mercChild() {
      if (this.result.data.mercChild) {
        return this.result.data.mercChild;
      }
      return {};
    },
    childScenic() {
      if (this.result.data.childScenic) {
        return this.result.data.childScenic;
      }
      return {};
    },
    desc() {
      if (this.result.data.childDesc) {
        return this.result.data.childDesc;
      }
      return {};
    },
    vr() {
      if (this.result.data.childVr) {
        return this.result.data.childVr;
      }
      return {};
    },
    inint() {
      this.params.container = document.getElementById(this.id);
      this.params.scenesArr = [
        {
          sceneId: "v1",
          sceneName: "赛车",
          // sceneFilePath:
          //  "http://whlyw.net:8073/Attachment/PuTian/ruiyunshan/1024/index.m3u8",
          sceneFilePath: this.result.data.childVr.sceneVr,
          sceneType: "Video"
        }
      ];
      this.videoList.push({
        Text: "超高清",
        Quality: 1,
        Resolution: "2048x1024",
        // M3U8:
        //   "http://whlyw.net:8073/Attachment/PuTian/ruiyunshan/1024/index.m3u8",
        M3U8: this.result.data.childVr.sceneVr,
        RTMP: null
      });
      initLoad(this.params, function(playMode) {}, this.tbConfig);
    }
  },
  watch: {
    $route: function(to, from) {
      // debugger
      if (
        from.name === "portal-dest-detail" &&
        to.name === "portal-dest-page"
      ) {
        document.getElementById(this.id).innerHTML = "";
        let idN = "vr" + Math.ceil(Math.random() * 100000000);
        //document.getElementById(this.id).id = idN;
        // this.id = idN;
        // console.log(this.id);
        this.videoList = [];
        this.params.container = null;
        this.params.scenesArr = [];
      }
    },
    result: function(to, from) {
      //debugger;
      if (!to.data || !to.data.childVr || !to.data.childVr.sceneVr) return;
      this.params.container = document.getElementById(this.id);
      this.params.scenesArr = [
        {
          sceneId: "v1",
          sceneName: "赛车",
          // sceneFilePath:
          //  "http://whlyw.net:8073/Attachment/PuTian/ruiyunshan/1024/index.m3u8",
          sceneFilePath: this.result.data.childVr.sceneVr,
          sceneType: "Video"
        }
      ];
      this.videoList.push({
        Text: "超高清",
        Quality: 1,
        Resolution: "2048x1024",
        // M3U8:
        //   "http://whlyw.net:8073/Attachment/PuTian/ruiyunshan/1024/index.m3u8",
        M3U8: this.result.data.childVr.sceneVr,

        RTMP: null
      });
      initLoad(this.params, function(playMode) {}, this.tbConfig);
    }
  }
};
</script>


<style type="text/scss" lang="scss">
@import "../../styles/portal/culture-travel.scss";
.el-alert__title {
  font-size: 16px;
  line-height: 18px;
}

#pan {
  // position: absolute;
  width: 100%;
  height: 400px;
  cursor: pointer;
}
.pan {
  width: 100%;
  height: 400px;
  cursor: pointer;
}
.key {
  background: #e8d9bc;
  color: #520000;
  font-weight: bold;
}
.el-button--info.is-plain:hover,
.el-button--info.is-plain:focus {
  background: #520000;
  border-color: #909399;
  color: #e8d9bc;
}

.quanjing {
  background: url(../../assets/portal/720noselected.png) no-repeat;
  background-size: cover;
  width: 95px;
  height: 35px;
  position: absolute;
  top: 80px;
  left: -12px;

  &.selected {
    background: url(../../assets/portal/720decideon.png) no-repeat;
    background-size: cover;
    width: 95px;
    height: 35px;
    position: absolute;
    top: 80px;
    left: -12px;
  }
}
.vr {
  background: url(../../assets/portal/VRnoselected.png) no-repeat;
  background-size: 100%;
  width: 95px;
  height: 35px;
  position: absolute;
  top: 140px;
  left: -12px;

  &.selected {
    background: url(../../assets/portal/VRvideodecideon.png) no-repeat;
    background-size: cover;
    width: 95px;
    height: 35px;
    position: absolute;
    top: 140px;
    left: -12px;
  }
}

.detail {
    background: #f5e8d3 !important;
    p{
          background: #f5e8d3 !important;
    }
}
</style>